import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=bd53128e&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd53128e')) {
      api.createRecord('bd53128e', component.options)
    } else {
      api.reload('bd53128e', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=bd53128e&", function () {
      api.rerender('bd53128e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28dA5JMfFc1wJ/JS/pricehelp.vue"
export default component.exports